
import Header from "../../../Components/Header/Header"
import Sidebar from "../../../Components/Sidebar/Sidebar"
import GardenDailyWorkCardManage from "./GarderDashboardComponent/GardenDailyWork/GardenDailyWorkManage"
import GardenMaintainanceCardManage from "./GarderDashboardComponent/GardenMaintainanceCard/GardenMaintainanceCardManage"
import GardenMasterCardManage from "./GarderDashboardComponent/GardenMasterCard/GardenMasterCardManage"
import GardenReopenCardManage from "./GarderDashboardComponent/GardenReopenCard/GardenReopenCardManage"
import GardenWorkAssignManage from "./GarderDashboardComponent/GardenWorkAssign/GardenWorkAssignManage"
import { Pie, Bar, Doughnut } from 'react-chartjs-2';
import { Dcoptions, Pieoptions, WorkAssign } from "../../../Helper/Data"
import React, { useEffect, useState } from 'react'
import { useAuthState } from "../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { GardenDashMainCountDataAPI } from "../../../Redux/MainCountSlice/GardenMainCount"
import { WardNameDataDDL } from "../../../Components/CommonDDL/WardNameDataDDL"
import { Loading } from "../../../Helper/Loading"
import WorkProgress from "./GarderDashboardComponent/GardenWorkAssign/WorkProgress"
import { useSearchParams } from "react-router-dom"
import { BaseUrl } from "../../../Helper/BaseUrl"
import GardenMaintainanceComp from "./GarderDashboardComponent/GardenMaintainanceCard/GardenMaintainanceComp"
import { WardnameHeaderDDL } from "../../../Components/CommonDDL/WardnameHeaderDDL"
import CommonDashboardWardNameDDL from "./CommonDashboardWardNameDDL"
import CivilWorkCardManage from "./GarderDashboardComponent/CivilWorkCard/CivilWorkCardManage"


export const OldGardenDashboard = () => {
    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 1,
        Label: "Select Ward",
    })
    const [Countdata, setCountdata] = useState({})
    // const [FinancialYearID, setFinancialYear] = useState('')
    const [HeaderFinancialYear, setHeaderFinancialYear] = useState('')
    const [HeaderMonthID, setHeaderMonthID] = useState('')
    const [MonthID, setMonthID] = useState('')
    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)
    const [WardValue, setWardValue] = useState(null)
    const [WardLabel, setWardLabel] = useState(null)
    const [HideYearMonth, setHideYearMonth] = useState('')
    const [AssetID, setAssetID] = useState(0)

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    // const [Month, setMonth] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",

    // })
    const handleGetFinancialYearID = (FinancialYear, Month) => {
        setHeaderMonthID(Month)
        setHeaderFinancialYear(FinancialYear)
    }

    // console.log(HeaderFinancialYear)

    useEffect(() => {
        const data = {
            M_FinancialYearID: year.ID,
            M_WardID: Ward.ID,
            M_MonthID: Month.ID,
            M_UserID: UserID,
            Flag: "WEB",
            token: token,
            handleGetCount: handleGetCount
        }
        if (year.ID !=0 && Month.ID!=0 && Ward.ID!=0) {
            dispatch(GardenDashMainCountDataAPI({ data }))
        }
    }, [year.ID, Month.ID, Ward.ID])

    const { GardenDashCountData, isLoading } = useSelector(state => state.GardenDashMainCountData)

    const handleGetCount = (data) => {
        // console.log("data", data)
        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setCountdata(tempData)
    }

    return (
        <>
            {isLoading && <Loading />}
            {/* <div className="main-content side_shrink position-relative border-radius-lg "></div> */}
            <div>
                <Header
                    // DashboardHeading="Garden Maintenance"
                    setYearValue={setYearValue}
                    setMonthValue={setMonthValue}
                    FinancialYear={FinancialYear}
                    setFinancialYear={setFinancialYear}
                    Month={Month}
                    setMonth={setMonth}
                    setYearLabel={setYearLabel}
                    setMonthLabel={setMonthLabel}
                    setWardValue={setWardValue}
                    setWardLabel={setWardLabel}
                    DashboardName={DashboardName}
                    HideYearMonthDDL='Dashboard'
                />
                {/* <Sidebar active="dashboard" /> */}
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        // active="gardenn" 
                        listActive="gardennn"
                    />
                   
                    <div className="content1 content">

                        {/* <div id="page-content-wrapper"> */}
                        {/* <div className="pcoded-main-container main-row">
                        <div className="pcoded-content "> */}
                        {/* <!-- [ breadcrumb ] start --> */}
                        {/* <WardnameHeaderDDL
                            WardName={WardName}
                            setWardName={setWardName}
                            WLable={WLable}
                            HWard={HWard}
                            flag={flag}
                        /> */}

                        <CommonDashboardWardNameDDL
                            setWardValue={setWardValue}
                            setWardLabel={setWardLabel}
                        />
                        {/* <!-- [ Main Content ] start --> <!--  --> */}
                        
                        {
                            RoleID == '1' &&
                            <GardenMaintainanceComp />
                        }

                        <div className="m-1  py-2 ps-lg-1 master_border">
                            <GardenMasterCardManage
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                                setAssetID={setAssetID}
                            />
                        </div>

                        <div className="row mt-4 m-1 py-2 pb-0 master_border">
                            <GardenDailyWorkCardManage
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                            />
                        </div>

                        <div className="row mt-4 m-1 py-2 pb-2 master_border d-flex align-items-center">
                            <GardenWorkAssignManage
                                HeaderFinancialYear={HeaderFinancialYear}
                                HeaderMonthID={HeaderMonthID}
                                Countdata={Countdata}
                                handleGetFinancialYearID={handleGetFinancialYearID}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                            />
                        </div>

                        <div className="row mt-4 m-1 py-2 pb-0 master_border px-2">
                            <CivilWorkCardManage
                                Countdata={Countdata}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                            />
                        </div>

                        <div className="row mt-4 m-1 py-2 pb-2 master_border px-2">
                            <WorkProgress
                                HeaderFinancialYear={HeaderFinancialYear}
                                HeaderMonthID={HeaderMonthID}
                                Countdata={Countdata}
                                handleGetFinancialYearID={handleGetFinancialYearID}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                            />
                        </div>

                        <div className="row mt-4 m-1 py-2 pb-2 master_border px-2">
                            <GardenReopenCardManage
                                HeaderFinancialYear={HeaderFinancialYear}
                                HeaderMonthID={HeaderMonthID}
                                Countdata={Countdata}
                                handleGetFinancialYearID={handleGetFinancialYearID}
                                YearValue={YearValue}
                                YearLabel={YearLabel}
                                MonthValue={MonthValue}
                                MonthLabel={MonthLabel}
                                WardValue={WardValue}
                                WardLabel={WardLabel}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                            />
                        </div>

                    </div>
                </div>
            </div>
        </>


    )
}